export default __webpack_public_path__ + "static/media/travail.9aa50641.svg";